export class DocumentManagmentClaims
{
    public static CanDeleteDocumenUploadFromVesselDocumentTab: string = 'CanDeleteDocumenUploadFromVesselDocumentTab';
    public static ShowDocumentRequirementInHome: string = "ShowDocumentRequirementInHome";
    public static CanaccessDocumentRequirements: string = "CanaccessDocumentRequirements";
    public static CanDeleteDocumentsFromDocumentManagementCentre: string = "CanDeleteDocumentsFromDocumentManagementCentre";
    public static ShowMyUploadsOnTheDMC: string = "ShowMyUploadsOnTheDMC";
}